export function MobileSkeletonLoader() {
  return (
    <div className="pointer-events-none relative z-0 flex h-full w-full flex-col gap-2 overflow-hidden bg-white before:absolute before:bottom-0 before:left-1/2 before:right-0 before:top-0 before:z-[1] before:-ml-[250%] before:w-[500%] before:animate-[shimmer_0.8s_linear_infinite] before:bg-gradient-to-r before:from-transparent before:from-[46%] before:via-white/35 before:via-[50%] before:to-transparent before:to-[54%] before:content-['']">
      {/* Top Menu Skeleton - Horizontal Layout */}
      <div className="mb-2 h-8 w-full rounded bg-gray-200" />

      {/* Main Content Skeleton */}
      <div className="flex flex-1 flex-col">
        {/* Tab navigation skeleton */}
        <div className="h-8 w-full rounded bg-gray-200" />

        {/* Main content skeleton */}
        <div className="relative my-4 box-border flex flex-1 overflow-hidden bg-white">
          <div className="h-full w-full rounded-md bg-gray-200" />
        </div>

        {/* Next button skeleton */}
        <div className="h-10 w-full rounded bg-gray-200" />
      </div>
    </div>
  );
}
